import { FormControl, IconButton, Input, InputLabel } from "@mui/material";
import React, { FC } from "react";
import InputAdornment from "@mui/material/InputAdornment";
import { VisibilityOff, Visibility } from "@mui/icons-material";

type BackgroundTypographyProps = {
  id?: string;
  name?: string;
  label?: string;
  required?: boolean;
  onChange?: Function;
};

export const Password: FC<BackgroundTypographyProps> = ({
  id,
  name,
  label,
  required,
  onChange,
}) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };
  const handleMouseUpPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };

  return (
    <FormControl
      variant="standard"
      fullWidth
      required={!!required}
      onChange={(e) => {
        if (onChange) {
          onChange(e);
        }
      }}
    >
      <InputLabel htmlFor={id || "password"}>{label || "Password"}</InputLabel>
      <Input
        name={name || "password"}
        id={id || "password"}
        type={showPassword ? "text" : "password"}
        fullWidth
        autoComplete="current-password"
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label={
                showPassword ? "hide the password" : "display the password"
              }
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              onMouseUp={handleMouseUpPassword}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
};
